module.exports = [
	{
		"name": "PSaaS Terms",
		"papers": [
			{
				"title": "PSaaS Terms",
				"id": "psaas-terms",
				"icon": "https://cdn.auth0.com/website/assets/pages/legals/img/icon-acrobat-7d1807772f.svg",
				"date": "December, 2017",
				"actions": [
					{
						"action": "download",
						"file": "https://cdn.auth0.com/website/auth0-legal/files/PSaaS-Terms-v2.1-12-11-17.pdf"
					},
					{
						"action": "open",
						"file": "https://cdn.auth0.com/website/auth0-legal/files/PSaaS-Terms-v2.1-12-11-17.pdf"
					}
				]
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/pages/legals/psaas/data/psaasPapers.json
// module id = 1415
// module chunks = 0